<p>dialog-discount works!</p>
